var t=(e=>(e.Radio="radio",e.Range="range",e.Checkbox="checkbox",e))(t||{});export{t as ContentKeys};
//# sourceMappingURL=form-content.types.js.map
